import script from "./KeywordManagerView.vue?vue&type=script&setup=true&lang=js"
export * from "./KeywordManagerView.vue?vue&type=script&setup=true&lang=js"

import "./KeywordManagerView.vue?vue&type=style&index=0&id=cfefc462&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfefc462"]])

export default __exports__